// extracted by mini-css-extract-plugin
export default {"centerman":"Container_centerman__niwMq","shop":"Container_shop__YSgAa"};